var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbot = function SvgChatbot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M1.854 5.135c0-.567.455-1.026 1.016-1.026h13.211c2.245 0 4.065 1.838 4.065 4.107v8.213c0 2.836-2.275 5.134-5.081 5.134H2.87c-.56 0-1.016-.46-1.016-1.027z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M6.425.77A.766.766 0 0 0 5.663 0a.766.766 0 0 0-.762.77v3.594c0 .425.341.77.762.77s.762-.345.762-.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    fillRule: "evenodd",
    d: "M7.936 10.764c0-.567.455-1.027 1.016-1.027.562 0 1.017.46 1.017 1.027v2.053c0 .567-.455 1.027-1.017 1.027-.56 0-1.016-.46-1.016-1.027zm2.15 6.198c-.416-.277-.623-.634-.625-1.039.01-.265.13-.379.228-.418.106-.042.332-.054.636.19l.014.012c.35.283.862.696 1.537.696l.056.001.027.002.027-.002.031-.001h2.033c.28 0 .508.23.508.513a.51.51 0 0 1-.508.514h-2.058l-.02-.002h-.021q-.027.003-.055.002c-.75 0-1.382-.183-1.81-.468m5.996-7.225c-.561 0-1.016.46-1.016 1.027v2.053c0 .567.455 1.027 1.016 1.027s1.016-.46 1.016-1.027v-2.053c0-.567-.455-1.027-1.016-1.027",
    clipRule: "evenodd"
  })));
};
export default SvgChatbot;